import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IField } from '../../Types/Field';
import { IFieldsState } from '../actions/fields.actions';
import { addField, deleteField, fetchAllFields } from '../middlewares/fields.middleware';

const initialState: IFieldsState = {
  fields: [],
  loading: false,
  saving: false,
  error: null,
}

const fieldsSlice = createSlice({
  name: 'fields',
  initialState: initialState,
  reducers: {
    loadingStart(state) {
      state.loading = true;
    },
    loadingFinished(state) {
      state.loading = false;
    },
    savingStart(state) {
      state.saving = true;
    },
    savingFinished(state) {
      state.saving = false;
    },
    replaceFields(state, action: PayloadAction<IField[]>) {
      state.fields = action.payload;
    },
    addField(state, action: PayloadAction<IField>) {
      const field: IField = action.payload;
      state.fields = [...(state.fields.filter((f) => f.id !== field.id)), field]
    },
    deleteField(state, action: PayloadAction<IField>) {
      const field: IField = action.payload;
      state.fields = state.fields.filter((f) => f.id !== field.id);
    },
    updateField(state, action: PayloadAction<IField>) {
      const field: IField = action.payload;
      state.fields = [ ...(state.fields.filter((f) => f.id !== field.id)), field ];
    }
  },
  extraReducers: (builder) => {

    builder.addCase(fetchAllFields.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchAllFields.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.fields = payload;
    });
    builder.addCase(fetchAllFields.rejected, (state, { payload }) => {
      state.loading = false;
      if (payload) { // ???
        state.error = "error loading"; // TODO: Translations
      }
    });

    builder.addCase(addField.pending, (state) => {
      state.saving = true;
    });
    builder.addCase(addField.fulfilled, (state) => {
      state.saving = false;
    });
    builder.addCase(addField.rejected, (state) => {
      state.saving = false;
    });

    builder.addCase(deleteField.pending, (state) => {
      state.error = null;
    });
    builder.addCase(deleteField.fulfilled, (state, { payload }) => {
      state.fields = state.fields.filter(f => f.id !== payload.id);
      state.loading = false;
    });
    builder.addCase(deleteField.rejected, (state, { payload }) => {
      state.loading = false;
      if (payload) { // ???
        state.error = "error deleting"; // TODO: Translations
      }
    });
  },
});

export default fieldsSlice;
export const fieldsReducer = fieldsSlice.reducer;
